import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import Appointment from "../interface/appointment";
import SearchControllsProps from "../interface/searchControllsProps";
import FilterCheckbox from "../../../components/inputs/filterCheckbox/filterCheckbox";

const CheckBoxCanceled = (): React.JSX.Element => {
  const {
    searchControlls,
    setSearchControlls,
    appointments,
    setPaginationSettings,
  }: {
    searchControlls: SearchControllsProps;
    setSearchControlls: React.Dispatch<
      React.SetStateAction<SearchControllsProps>
    >;
    appointments: Appointment[] | null;
    setPaginationSettings: React.Dispatch<React.SetStateAction<any>>;
  } = React.useContext(AppointmentOverviewContext);

  const getCancelledCount = (): number => {
    return appointments
      ? appointments.filter(
          (appointment: Appointment) => appointment.status === "K"
        ).length
      : 0;
  };

  const onClickHandler = (): void => {
    setPaginationSettings((prev: any) => ({
      ...prev,
      page: 1,
    }));
    setSearchControlls((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        cancelled: !prev.status.cancelled,
      },
    }));
  };

  return (
    <FilterCheckbox
      disabled={searchControlls.loading}
      badgeContent={getCancelledCount()}
      onClickHandler={onClickHandler}
      label="Storniert"
      checked={searchControlls.status.cancelled}
    />
  );
};

export default CheckBoxCanceled;
